import { z } from "zod";

/** Each time-spent field is capped at two days. */
export const MAX_TIME_SPENT_MINUTES = 2880;

// An empty NumberInput holds "", which means the value was not recorded.
const timeSpentMinutesField = z.preprocess(
  (value) => (value === "" ? undefined : value),
  z
    .number({ invalid_type_error: "Enter a number of minutes" })
    .int("Enter whole minutes")
    .min(0, "Minutes can't be negative")
    .max(MAX_TIME_SPENT_MINUTES, "Minutes can't exceed 2,880 (2 days)")
    .optional(),
);

/** Zod schema for the Time Spent During Encounter drawer. Both fields are optional. */
export const encounterTimeSpentFormSchema = z.object({
  faceToFaceMinutes: timeSpentMinutesField,
  careCoordinationMinutes: timeSpentMinutesField,
});
